window.dtPeriod = function () {
  const dt_period = new DataTable('#period-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#period-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#period-datatable', 5); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "name" },
      { "data": "begin_date" },
      { "data": "end_date" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()

  $(document).off("click", "#btn-generate-period")
  $(document).on("click", "#btn-generate-period", function(){
    Notiflix.Confirm.show(
      'Confirm',
      'Generate new period?',
      'Yes',
      'No',
      () => {
        $.ajax({
          url: window.location.href,
          method: "POST",
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
          dataType: "json",
          success: function (data) {
            if (data.message != undefined){
              Notiflix.Notify.success(data.message, {position: 'right-bottom', useIcon: false});
            }
            dt_period.ajax.reload()
          },
          error: function (jqXHR) {
            Notiflix.Notify.failure(jqXHR.responseJSON.message, {position: 'right-bottom', useIcon: false});
          },
        })
      },
      () => { },
      {},
    );
  })
}

 